import React, { useEffect, useState } from 'react';
import { addTicketMessage, fetchTicketMessages } from '../../lib/support/ticketsService';

const TicketDrawer = ({ firebase, ticket, onClose }) => {
  const [messages, setMessages] = useState([]);
  const [reply, setReply] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (!ticket?.id) return undefined;
    fetchTicketMessages(firebase, ticket.id).then((data) => {
      if (mounted) setMessages(data);
    });
    return () => {
      mounted = false;
    };
  }, [firebase, ticket]);

  const handleSend = async () => {
    if (!reply.trim()) return;
    setSubmitting(true);
    try {
      await addTicketMessage(firebase, ticket.id, {
        sender: 'user',
        text: reply.trim(),
        attachments: [],
      });
      setMessages((prev) => [...prev, { sender: 'user', text: reply.trim() }]);
      setReply('');
    } finally {
      setSubmitting(false);
    }
  };

  if (!ticket) return null;

  return (
    <div className="support-ticket-drawer">
      <div className="support-modal-header">
        <div>
          <div style={{ fontWeight: 600 }}>{ticket.subject}</div>
          <div style={{ fontSize: '0.8rem', color: '#9b9b9b' }}>{ticket.ticketNumber}</div>
        </div>
        <button className="support-btn" onClick={onClose}>Close</button>
      </div>
      <div className="support-drawer-body">
        {messages.length === 0 ? (
          <div className="support-empty">No messages yet.</div>
        ) : (
          messages.map((message, index) => (
            <div key={message.id || index} className={`support-message ${message.sender || 'user'}`}>
              <div style={{ fontSize: '0.85rem', color: '#bdbdbd', marginBottom: '0.35rem' }}>
                {message.sender === 'support' ? 'Support' : 'You'}
              </div>
              <div>{message.text || 'Attachment'}</div>
            </div>
          ))
        )}
      </div>
      <div className="support-reply">
        <textarea
          rows={3}
          placeholder="Write a reply?"
          value={reply}
          onChange={(event) => setReply(event.target.value)}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0.5rem' }}>
          <button className="support-btn primary" disabled={submitting} onClick={handleSend}>
            {submitting ? 'Sending?' : 'Send'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TicketDrawer;
